// extracted by mini-css-extract-plugin
module.exports = {"root":"branch-leading_root__1VLP8","inverted":"branch-leading_inverted__2AOgu","title":"branch-leading_title__3ngSi","icon":"branch-leading_icon__1-uP-"};